import React, { useState, useEffect } from "react";
import "../css/login.css";
import classes from "../css/Tabs.module.css";
import {useNavigate,useLocation} from "react-router-dom";
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";
import {getPacks,subscribe } from "../../services/auth-api";
import {upgrade} from "../../services/home";
import { useTranslation } from "react-i18next";
import {Loader} from "../../utils/loader";
import { PopupSub } from '../../utils/constant';
import { NavLink } from "react-router-dom";

const UpgradePack = () => {
  const { t} = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [packs, setPacks] = useState([]); // State to store packs data
  const [pack, setPack] = useState({"packPrice":20,"packCurrency":"MT","packFrequency":"Weekly"}); // State to store packs data
  const [selectedPack, setSelectedPack] = useState(2);
  const oldPack =localStorage.getItem('oldPack') || 1;
  const [flow, setFlow] = useState(''); // State to track flow
  const [message, setMessage] = useState({message: "",error: true});
  const [popup, setPopup] = useState(false);
  const [subStatus, setSubStatus] = useState(0);

    

  const handlePackSelection = (pack) => {
    setSelectedPack(pack.id);
    setPack(pack);
  };

  useEffect(() => {
      setMessage({ message: "", error: false});
      if(oldPack>1)
      {
        setSelectedPack(3);
        setPack({"packPrice":50,"packCurrency":"MT","packFrequency":"Monthly"});   
      }       
      var userId=null;
      getPacks(userId).then((res) => {
          setPacks(res?.data); // Set packs data
          //packs.map((pack) => (selectedPack === pack.id && setPack(pack)));                  
        })
        .catch((err) => {
          console.log(err);
        });
  },[]);



  const handleSubscription = async () => {
      setMessage({ message: "", error: true});
        setLoading(true);
        await upgrade({packId:selectedPack,mode:'WAP'})
        .then((res) => {         
          localStorage.setItem("token", res.data.accessToken);
          setSubStatus(138);setPopup(true);
        }).catch((err) => {
          console.log(err);
          setMessage({message: t('132'),error: true,});
        }).finally(() => setLoading(false));
  }

  const redirectToPage = (page) => {
    navigate(page);
  }
    const redirectTo = async (input) => {
        if(input && input.length>2)navigate(input);
        else {setSubStatus(0);setPopup(false);}
    }

  return (
    packs &&
    <div className="home">
      <div className="maine-div">
          <div className="container-fluid box-wrapper login">          
            <div className="page-header pb-5">
              <div className="box-wrapper mx-auto text-center position-relative">
                  <NavLink to="/profile" className="page-header-back"><img src="/image/back.png" className='arrow' alt="Avatar" /></NavLink>
                  <span className="modal-level-title levels-title">{t('137')}</span>
              </div>
          </div>               
        
          <div className="login-info">  
            <h3 className="login-title-red mb-3 mt-3 text-center">{t("137")}</h3>
               <hr/>
            {flow === "CONFIRM" ?(
                <div className="text-center">
                      <h3 className="login-title mb-3 mt-3 text-center">{t("111")} <span className="span-bold">
                        { pack.packPrice +" "+pack.packCurrency+" "+ t(pack.packFrequency)}</span></h3>
                      <h3 className="login-title mb-3 mt-3 text-center">{t("113")}</h3>
                      {message.message && <div className="mb-3"><p className={`alert alert-${message.error ? 'danger' : 'success'}`}>{message.message}</p> </div>}
                      {loading ? <Loader />:<>
                      <button className="btn btn-primary btn-pm-green" type="button" onClick={handleSubscription} >{t("87")}</button>
                      <button className="btn btn-primary btn-pm-red" type="button" onClick={()=>setFlow('')}>{t("88")}</button>
                      </>}
                    
                </div>
            ):(  // New user Flow      
              <>               
                {/*<h3 className="header mb-1 mt-1 text-center">{t("114")}</h3>*/}
                 <div className="text-center radio">
                  {packs.map((pack) => (pack.id>oldPack &&
                   <label key={pack.id} className="pack">
                          <input type="radio" id="rd1" checked={selectedPack === pack.id} onChange={() => handlePackSelection(pack)} />
                          {pack.packPrice +" "+pack.packCurrency+" "+ t(pack.packFrequency)}
                    </label>                    
                  ))}
                </div>
                <div className="phone-input"> 
                  {message.message && (<div className="mb-3"><p className={`alert alert-${ message.error ? "danger" : "success"}`} > {message.message} </p></div>)}
                  {loading ? <Loader />:<>
                  <button
                    className="pack-btn btn btn-primary btn-pm-custom-red" onClick={()=> setFlow('CONFIRM')}>  { t("115") }
                  </button>
                  <br/><br/>
                  <div className="text-center">
                  <h3 className="header1 mb-1 mt-1 text-center">{t("117")+" "+
                      pack.packPrice +" "+pack.packCurrency+" "+ t(pack.packFrequency)+" "+t("118")}</h3>
                       <a className="linkBlack linkSize" onClick={() => {redirectToPage('/terms')}}>&nbsp;{t("122")}</a>
                   </div>
                  </>
                  }
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {popup && <PopupSub redirectTo={redirectTo} subStatus={subStatus} location="/home" />}
    </div> 
       
  );
};

export default UpgradePack;
